import { saiAxios } from './saiAxios'
import { toDomainHttpClient } from './toDomainHttpClient'

// 트래킹 이벤트명(mp_event_name)은 maxios 와 같이 쿼리 파라미터에 싣는다.
export const domainSaiHttpClient = toDomainHttpClient(saiAxios, { forwardMeta: true })
